Creates a new unposted position profile for an opening.

If the position opening already contains 25 position profiles this will fail with a `BAD_USER_INPUT` error.
